import { Box, Typography } from '@mui/material';
import React from 'react';

export default function BlankPage() {
    return (
        <Box>
            <Typography variant="caption" color="initial">Blank Page</Typography>
        </Box>
    )
}